module.exports = __webpack_public_path__ + "media/images/landing/en/manage-2602217b000051198469ab6d6e800a4d.webp";